import { compKey } from './key';
import { createButtonDriver, createLabelDriver } from '../../new-libby/drivers';
export var createNotificationItemDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    var labelDriver = createLabelDriver(base);
    var toggleReadButtonDriver = createButtonDriver(base);
    return {
        descriptionText: base.$('.description').text,
        titleText: base.$('.title').text,
        labelText: labelDriver.text,
        isIconExists: base.$('.icon-container').exists,
        hasAction: function () { return base.hasClass('has-action'); },
        isRead: function () { return base.hasClass('read'); },
        click: base.click,
        toggleRead: toggleReadButtonDriver.click,
        base: base,
    };
};
//# sourceMappingURL=driver.js.map